export const farmStructureActionTypes = {
  SELECT_GROWER: 'SELECT_GROWER',
  SELECT_SEASON: 'SELECT_SEASON',
  SELECT_FARM: 'SELECT_FARM',
  SELECT_FIELD: 'SELECT_FIELD',
  FORCE_UPDATE_FARM_STRUCTURE: 'FORCE_UPDATE_FARM_STRUCTURE'
};
